import React from 'react';
import PropTypes from 'prop-types';
import { useUrlBuilder } from 'hooks/useUrlBuilder';
import { CookiePolicyButton, CookiePolicyLink, CookiePolicyText, CookiePolicyWrapper } from './styled';
import { privacy } from '../../helpers/routes';

const EuCookieBanner: React.ComponentType<{
  handleClick: () => {};
  isDesktop: boolean;
}> = ({ isDesktop, handleClick }) => {
  const { localized } = useUrlBuilder();
  return (
    <CookiePolicyWrapper data-cy="cookie-policy-banner" isDesktop={isDesktop}>
      <CookiePolicyText isDesktop={isDesktop}>
        We use cookies to improve your shopping experience. By continuing to use our site, you are agreeing to receive
        all cookies. {isDesktop && <br />} Please read our{' '}
        <CookiePolicyLink href={localized(privacy)}>Privacy Policy</CookiePolicyLink> for more information.
      </CookiePolicyText>
      <CookiePolicyButton isDesktop={isDesktop} onClick={handleClick}>
        accept
      </CookiePolicyButton>
    </CookiePolicyWrapper>
  );
};

EuCookieBanner.propTypes = {
  handleClick: PropTypes.func.isRequired,
  isDesktop: PropTypes.bool,
};

export default EuCookieBanner;
